export const semestreNormalize = (x) => ({
    idSemestre: x.idSemestre ?? x.IdSemestre ?? 0,
    idCarrera: x.idCarrera ?? x.IdCarrera ?? 0,
    nombre: x.nombre ?? x.Nombre ?? '',
    idSemestreAnterior: x.idSemestreAnterior ?? x.IdSemestreAnterior ?? null,
    activo: x.activo ?? x.Activo ?? true,
});
